// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.migration-tracker .migration-item {
  transition: background-color 0.2s ease;
}
.migration-tracker .migration-item:hover {
  background-color: #f8f9fa;
}
.migration-tracker .migration-item.selected {
  background-color: #e7f3ff;
  border-left: 3px solid #0073ea;
}
.migration-tracker .stat-card {
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  text-align: center;
}
.migration-tracker .stat-card .stat-label {
  font-size: 0.875rem;
  color: #676879;
  margin-bottom: 4px;
}
.migration-tracker .stat-card .stat-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: #323338;
}
.migration-tracker .stat-card .stat-failed {
  font-size: 0.75rem;
  margin-top: 4px;
}
.migration-tracker .migration-details ul {
  margin-bottom: 0;
  padding-left: 1.5rem;
}
.migration-tracker .migration-details ul li {
  margin-bottom: 4px;
}
.migration-tracker .accordion-button:not(.collapsed) {
  background-color: #f8f9fa;
  color: #323338;
}
.migration-tracker .accordion-button:focus {
  box-shadow: none;
  border-color: rgba(0, 0, 0, 0.125);
}
.migration-tracker .progress {
  height: 20px;
  border-radius: 8px;
}
.migration-tracker .card {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Components/MigrationTracker/MigrationTracker.scss"],"names":[],"mappings":"AACE;EACE,sCAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAGI;EACE,yBAAA;EACA,8BAAA;AADN;AAKE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAHN;AAMI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAJN;AAOI;EACE,kBAAA;EACA,eAAA;AALN;AAUI;EACE,gBAAA;EACA,oBAAA;AARN;AAUM;EACE,kBAAA;AARR;AAcI;EACE,yBAAA;EACA,cAAA;AAZN;AAeI;EACE,gBAAA;EACA,kCAAA;AAbN;AAiBE;EACE,YAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,wCAAA;AAhBJ","sourcesContent":[".migration-tracker {\n  .migration-item {\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    &.selected {\n      background-color: #e7f3ff;\n      border-left: 3px solid #0073ea;\n    }\n  }\n\n  .stat-card {\n    padding: 12px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    text-align: center;\n\n    .stat-label {\n      font-size: 0.875rem;\n      color: #676879;\n      margin-bottom: 4px;\n    }\n\n    .stat-value {\n      font-size: 1.25rem;\n      font-weight: 600;\n      color: #323338;\n    }\n\n    .stat-failed {\n      font-size: 0.75rem;\n      margin-top: 4px;\n    }\n  }\n\n  .migration-details {\n    ul {\n      margin-bottom: 0;\n      padding-left: 1.5rem;\n\n      li {\n        margin-bottom: 4px;\n      }\n    }\n  }\n\n  .accordion-button {\n    &:not(.collapsed) {\n      background-color: #f8f9fa;\n      color: #323338;\n    }\n\n    &:focus {\n      box-shadow: none;\n      border-color: rgba(0, 0, 0, 0.125);\n    }\n  }\n\n  .progress {\n    height: 20px;\n    border-radius: 8px;\n  }\n\n  .card {\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
